import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AbstractBasketComponent } from '@df/basket/abstract-basket.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ButtonStyleComponent } from '../../../common/buttons/button-style/button-style.component';

@Component({
    selector: 'basket-view-submit',
    templateUrl: 'basket-view-submit.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule, ButtonStyleComponent, RouterModule]
})
export class BasketViewSubmitComponent extends AbstractBasketComponent {
    protected get disabled() {
        return !this.basket.isSalable || this.basket.data.checkout_disallow;
    }
}
